import { gql } from '@apollo/client';

export const PROPERTY_LOCATION_FRAGMENT = gql`
  fragment PropertyLocation on Property {
    location {
      coordinates {
        lat
        lon
      }
      county
      municipalityArea
    }
  }
`;
